// base
import { createAction } from '@reduxjs/toolkit';

//default
export const QNA = 'qna';

//slice
export const QNA_SLICE_NAME = `${QNA}Slice`;

// action
export const GET_QNA_LIST = `${QNA}/search`;
export const GET_QNA_STATICS = `${QNA}`;
export const GET_QNA_DETAIL = `${QNA}/detail`;
export const GET_QNA_UPDATE = `${QNA}/update`;
export const GET_QNA_MODIFY = `${QNA}/modify`;
export const DELETE_QNA = `${QNA}/delete`;
export const GET_QNA_COMMENT = `${QNA}/comment`;
export const GET_QNA_COMMENT_MODIFY = `${QNA}/comment/modify`;
export const GET_QNA_COMMENT_DELETE = `${QNA}/comment/delete`;
export const GET_QNA_PIC_DOWNLOAD = `${QNA}/downloads`;

const getQnaSearchAction = createAction(GET_QNA_LIST);
const getQnaDetailAction = createAction(GET_QNA_DETAIL);
const postQnaAction = createAction(GET_QNA_UPDATE);
const getQnaModifyAction = createAction(GET_QNA_MODIFY);
const deleteQnaAction = createAction(DELETE_QNA);
const getQnaCommentAction = createAction(GET_QNA_COMMENT);
const getQnaCommentModifyAction = createAction(GET_QNA_COMMENT_MODIFY);
const getQnaCommentDeleteAction = createAction(GET_QNA_COMMENT_DELETE);
const getQnaPicDownload = createAction(GET_QNA_PIC_DOWNLOAD);

// actions
export const actions = {
  getQnaSearchAction,
  getQnaDetailAction,
  postQnaAction,
  getQnaModifyAction,
  deleteQnaAction,
  getQnaCommentAction,
  getQnaCommentModifyAction,
  getQnaCommentDeleteAction,
  getQnaPicDownload
};
